import settings from '~/settings.json'
import type { StoreSettings } from '~/types'

export const useSettings = (): StoreSettings => settings as StoreSettings
